import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { environment } from './../../../../environments/environment';
import { IrrigationZone } from '../../_models/irrigation/irrigationZone';
import { Crop } from '../../_models';

@Injectable()
export class IrrigationZoneService {
  private apiBaseUrl = environment.apiBaseUrl;
  zoneItemObj: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  commodityObjSelected: Subject<any> = new Subject<any>();
  list: BehaviorSubject<Array<IrrigationZone>> = new BehaviorSubject<Array<IrrigationZone>>([]);
  insubstantialCrop = false;
  insubstantialVariety = false;
  // NOn più utilizzata
  cropsActivated: any[] = [
    {
      commodityIds: [1692],
      name: 'lives',
      imageUrl: 'https://cdn.xfarm.ag/commodities/vite.jpg',
    },
    {
      commodityIds: [1481],
      name: 'apple_tree',
      imageUrl: 'https://cdn.xfarm.ag/commodities/melo.jpg',
    },
    {
      commodityIds: [1832, 1731],
      name: 'cherry_tree',
      imageUrl: 'https://cdn.xfarm.ag/alert/template/Ciliegio.jpg',
    },
    {
      commodityIds: [1855, 1856],
      name: 'peach',
      imageUrl: 'https://cdn.xfarm.ag/commodities/pesco.jpg',
    },
    {
      commodityIds: [1528, 1823],
      name: 'tomato',
      imageUrl: 'https://cdn.xfarm.ag/commodities/pomodoro.png',
    },
    {
      commodityIds: [1702],
      name: 'olivo',
      imageUrl: 'https://cdn.xfarm.ag/commodities/olivo.jpg',
    },
    {
      commodityIds: [1833, 1883],
      name: 'plum',
      imageUrl: 'https://cdn.xfarm.ag/commodities/susino.jpg',
    },
    {
      commodityIds: [1552],
      name: 'however',
      imageUrl: 'https://cdn.xfarm.ag/commodities/pero.jpg',
    },
    {
      commodityIds: [1564],
      name: 'lemon',
      imageUrl: 'https://cdn.xfarm.ag/commodities/default_commodity.jpg',
    },
    {
      commodityIds: [1561],
      name: 'orange',
      imageUrl: 'https://cdn.xfarm.ag/commodities/arancie.jpg',
    },
    {
      commodityIds: [1691],
      name: 'pomegranate',
      imageUrl: 'https://cdn.xfarm.ag/commodities/melograno.jpg',
    },
    {
      commodityIds: [1858],
      name: 'kiwi_kiwi_',
      imageUrl: 'https://cdn.xfarm.ag/commodities/kiwi.jpg',
    },
    {
      commodityIds: [1447],
      name: 'corn',
      imageUrl: 'https://cdn.xfarm.ag/commodities/mais.jpg',
    } /*,
    {
      commodityIds: [1922],
      name: 'coffee_arabica',
      imageUrl: 'https://cdn.xfarm.ag/commodities/coffee_arabica.jpg'
    }*/,
  ];

  constructor(private http: HttpClient) {}

  checkCropAndVariety(crop: Crop, commodityId, varietyId) {
    if (crop && crop.commodity && crop.commodity.id !== commodityId) {
      this.insubstantialCrop = true;
    } else {
      this.insubstantialCrop = false;
    }
    if (crop && crop.variety) {
      if (crop.variety.id !== varietyId) {
        this.insubstantialVariety = true;
      } else {
        this.insubstantialVariety = false;
      }
    }
  }

  initZoneObj() {
    this.zoneItemObj = new BehaviorSubject<any>(null);
  }

  getList(): Observable<IrrigationZone[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/irrigation/irrigationZones').pipe(
      map((response) => {
        this.list.next(response);
        return response;
      })
    );
  }

  getIrrigationZoneById(idIrrigationZone): Observable<IrrigationZone> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/irrigation/irrigationZones/' + idIrrigationZone)
      .pipe(map((response) => response));
  }

  getExternalCommodities(): Observable<any[]> {
    return this.http
      .get<any>(
        this.apiBaseUrl + 'api/private/v1/irrigation/externalCommodities?externalSource=IDROPLAN'
      )
      .pipe(map((response) => response));
  }

  getExternalVarieties(varietyId, module?: string): Observable<any[]> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v1/irrigation/externalVarieties?commodity=' +
          varietyId +
          '&module=' +
          module
      )
      .pipe(map((response) => response));
  }

  saveZone(irrigationZoneItem): Observable<IrrigationZone> {
    const irrigationZone = { ...irrigationZoneItem };
    delete irrigationZone.lastUpdated;
    delete irrigationZone.dateCreated;
    delete irrigationZone.irrigationAdvice;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    irrigationZone.companyId = companySelected ? companySelected.id : null;

    if (irrigationZone.id) {
      return this.http
        .put<IrrigationZone>(
          this.apiBaseUrl + 'api/private/v1/irrigation/irrigationZones/' + irrigationZone.id,
          irrigationZone
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<IrrigationZone>(
          this.apiBaseUrl + 'api/private/v1/irrigation/irrigationZones',
          irrigationZone
        )
        .pipe(map((response) => response));
    }
  }

  deleteIrrigationZone(irrigationZone: IrrigationZone): Observable<IrrigationZone> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/irrigation/irrigationZones/' + irrigationZone.id)
      .pipe(map(() => ({ id: irrigationZone.id }) as IrrigationZone));
  }

  getCommodityObjSelected = () => {
    return this.commodityObjSelected.asObservable();
  };

  updateCommodityObjSelected(bool: boolean) {
    this.commodityObjSelected.next(bool);
  }

  getCheckOnExistingCrop(itemZone): boolean {
    if (!itemZone.crops || itemZone.crops.length === 0) {
      return false;
    } else if (itemZone.crops && _.includes(itemZone.crops, null)) {
      return false;
    } else {
      return true;
    }
  }

  getCheckOnExistingSensor(itemZone): boolean {
    if (!itemZone.sensorList || itemZone.sensorList.length === 0) {
      return false;
    } else if (itemZone.sensorList && _.includes(itemZone.sensorList, null)) {
      return false;
    } else {
      return true;
    }
  }

  getCheckOnExistingWeatherStation(itemZone): boolean {
    if (!itemZone.weatherStation) {
      return false;
    } else {
      return true;
    }
  }
}
